<script>
export default {
  name: 'CategoryForm',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'submit'],
  data() {
    return {
      specTypeOptions: [
        { label: 'APPAREL_SIZE', value: 'APPAREL_SIZE' },
        { label: 'PRODUCT_OPTION', value: 'PRODUCT_OPTION' },
        { label: 'PACK_COUNT', value: 'PACK_COUNT' },
      ],
      localForm: {
        category_id: null,
        name: '',
        default_spec_type: 'PRODUCT_OPTION',
        is_active: true,
      }
    }
  },
  watch: {
    modelValue(next) {
      if (next) this.syncForm()
    },
    initialData: {
      deep: true,
      handler() {
        if (this.modelValue) this.syncForm()
      }
    }
  },
  methods: {
    normalizeDefaultSpecType(value) {
      const allowed = ['APPAREL_SIZE', 'PRODUCT_OPTION', 'PACK_COUNT']
      return allowed.includes(value) ? value : 'PRODUCT_OPTION'
    },
    syncForm() {
      this.localForm = {
        category_id: this.initialData?.category_id || null,
        name: this.initialData?.name || '',
        default_spec_type: this.normalizeDefaultSpecType(this.initialData?.default_spec_type),
        is_active: this.initialData?.is_active !== undefined ? !!this.initialData.is_active : true,
      }
    },
    close() {
      this.$emit('update:modelValue', false)
    },
    submit() {
      this.$emit('submit', {
        category_id: this.localForm.category_id,
        name: String(this.localForm.name || '').trim(),
        default_spec_type: this.localForm.default_spec_type,
        is_active: !!this.localForm.is_active,
      })
    }
  },
  mounted() {
    this.syncForm()
  }
}
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="min-width: 420px; max-width: 90vw;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">{{ localForm.category_id ? '카테고리 수정' : '카테고리 등록' }}</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="close" />
      </q-card-section>

      <q-card-section>
        <q-input
          v-model="localForm.name"
          label="카테고리명"
          outlined
          dense
          autofocus
          class="q-mb-md"
        />
        <q-select
          v-model="localForm.default_spec_type"
          :options="specTypeOptions"
          emit-value
          map-options
          label="기본 규격 타입"
          outlined
          dense
          class="q-mb-md"
        />
        <q-toggle
          v-model="localForm.is_active"
          label="활성 여부"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="취소" @click="close" />
        <q-btn color="primary" label="저장" @click="submit" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
